document.querySelectorAll('[data-announcement-strip]').forEach(function(strip) {
  var button = strip.querySelector('[data-strip-pause]');
  if (!button) return;
  button.addEventListener('click', function() {
    var paused = button.getAttribute('aria-pressed') !== 'true';
    button.setAttribute('aria-pressed', String(paused));
    strip.classList.toggle('is-paused', paused);
    var english = document.documentElement.lang.indexOf('en') === 0;
    button.setAttribute('aria-label', paused ? (english ? 'Resume announcement animation' : 'Reanudar animación de anuncios') : (english ? 'Pause announcement animation' : 'Pausar animación de anuncios'));
    button.firstElementChild.textContent = paused ? '▷' : 'Ⅱ';
  });
});
